import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { DataElement } from '../shared/models/data-element.model';
import { StringUtilityService } from '../shared/services/string-utility.service';
export class DataElementComponent  {
   DataElements: DataElement[] = [];
   FormValues: Object = {};
   ValidationBlocks = [];
  formInitialized = true;
  defaultOption = 'Select';
/**
 * @param {?} stringUtilityService
 */
constructor(private stringUtilityService: StringUtilityService) {}
/**
 * @return {?}
 */
itemSelected() {
  }
/**
 * @param {?} cond
 * @return {?}
 */
evaluate(cond) {
     return eval(cond);
  }
/**
 * @param {?} DataElementID
 * @param {?} choiceValue
 * @param {?} event
 * @return {?}
 */
updateMultichoice(DataElementID, choiceValue, event) {
    let /** @type {?} */ previousValue = this.FormValues[DataElementID];
    if (event.currentTarget.checked) {
      if (previousValue === undefined) {
        previousValue = [];
      }
      previousValue.push(choiceValue);
    } else {
      const /** @type {?} */ index = previousValue.indexOf(choiceValue);
      if (index > -1) {
        previousValue.splice(index, 1);
      }
    }
    this.FormValues[DataElementID] = previousValue;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'acr-data-element',
  template: `
    <canvas id='Can-ImgMap'>

    </canvas>
    <ng-container *ngFor="let DataElement of DataElements">



      <ng-container *ngIf="(DataElement.ElementType == 'ComputedElement')">
        <acr-computed-element [DataElement]="DataElement" [DataElements]="DataElements" [FormValues]="FormValues"></acr-computed-element>
      </ng-container>


      <ng-container *ngIf="(DataElement.ElementType == 'ChoiceDataElement' || DataElement.ElementType == 'NumericDataElement' || DataElement.ElementType == 'IntegerDataElement' || DataElement.ElementType == 'MultiChoiceDataElement') ">
        <ng-container *ngIf="DataElement.Visible">
          <div class="form-group " [class.Visible]="DataElement.Visible">
            <div class="col-xs-12 col-sm-5 text-left content-padding">
              <label class="control-label DEElement" id="{{DataElement.ID}}">
                {{DataElement.Label}}
              </label>
              <ng-container *ngIf="!stringUtilityService.isEmpty(DataElement.Hint) ">
                <a>
                  <span class="glyphicon glyphicon-info-sign" data-toggle="tooltip" data-placement="right" title="{{DataElement.Hint}}"></span>
                </a>
              </ng-container>
              <ng-container *ngIf="DataElement.Diagrams != undefined ">
                <acr-hint-diagram [DataElement]="DataElement"></acr-hint-diagram>
              </ng-container>
              <ng-container *ngIf="ValidationBlocks.length > 0">
                <ng-container *ngFor="let Block of ValidationBlocks">
                  <ng-container *ngIf="(DataElement.Visible)">
                    <ng-container *ngIf="evaluate(Block.Condition)">
                      <ng-container *ngIf="Block.DataElementID == DataElement.ID">
                        <ng-container *ngIf="Block.Message =='Minimum value required'">
                          <span class="required-field">Minimum Value: {{Block.Minimum}}</span>
                        </ng-container>
                        <ng-container *ngIf="Block.Message != 'Minimum value required'">
                          <span class="required-field">* Required field !!!</span>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>

            <div class="col-xs-12 col-sm-7 text-left content-padding">
              <div class="input-group ">
                <!--Choice DataElements-->
                <ng-container *ngIf="DataElement.ElementType == 'ChoiceDataElement' ">
                  <div class="row">
                    <ng-container *ngIf="DataElement.ChoiceOptions.length == 2">
                      <!-- Full width for radio if Imagepath exist -->
                      <ng-container *ngIf="DataElement.ImagePath != undefined">
                        <div id="radio-inline">
                          <ng-container *ngFor="let choice of DataElement.ChoiceOptions">
                              <div class="row">
                                  <div class="col-sm-12">
                            <label class="rad DEValues">
                              <input type="radio" [(ngModel)]="FormValues[DataElement.ID] " name="FormValues['{{DataElement.ID}}']" value={{choice.Value}}
                                checked style="display:none;">
                              <div  (click)="itemSelected()">
                                <input class="hideInput" type="radio" [(ngModel)]="FormValues[DataElement.ID] " name="FormValues['{{DataElement.ID}}']" value={{choice.Value}}
                                  checked>
                                <span>{{choice.Label}}</span>

                              </div>
                              <div class="clear"></div>
                            </label>
                            </div></div>
                          </ng-container>
                        </div>
                      </ng-container>
                      <!-- Full width for radio if Imagepath does not exist -->
                      <ng-container *ngIf="DataElement.ImagePath == undefined">
                        <div id="radio-inline">
                          <ng-container *ngFor="let choice of DataElement.ChoiceOptions">
                            <div class="row">
                                <div class="col-sm-12">
                                    <label class="rad DEValues">
                                        <input type="radio" [(ngModel)]="FormValues[DataElement.ID] " name="FormValues['{{DataElement.ID}}']" value={{choice.Value}}
                                          checked style="display:none;">
                                        <div  (click)="itemSelected()" >
                                          <input class="hideInput" type="radio" [(ngModel)]="FormValues[DataElement.ID] " name="FormValues['{{DataElement.ID}}']" value={{choice.Value}}
                                            checked>
                                          <span>{{choice.Label}}</span>
                                        </div>

                                      </label>
                                </div>
                            </div>

                          </ng-container>
                        </div>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="DataElement.ChoiceOptions.length != 2">
                      <!-- Dropdown will be created if choice options have more than 5 choices-->
                      <ng-container *ngIf="DataElement.ChoiceOptions.length > 5">
                        <select id="{{DataElement.ID}}" [(ngModel)]="FormValues[DataElement.ID]" (ngModelChange)="itemSelected()">
                          <option [value]="Select">--Select--</option>
                          <option *ngFor="let choice of DataElement.ChoiceOptions" [value]="choice.Value">{{choice.Label}}</option>
                        </select>
                      </ng-container>
                      <!-- Radio button will be created if choice options have are <=5 choices-->
                      <ng-container *ngIf="DataElement.ChoiceOptions.length <= 5">
                        <ng-container *ngFor="let choice of DataElement.ChoiceOptions">
                          <div id="radio-inline">
                              <div class="row">
                                  <div class="col-sm-12">
                                    <label class="rad DEValues">
                                      <input type="radio" [(ngModel)]="FormValues[DataElement.ID] " name="FormValues['{{DataElement.ID}}']" value={{choice.Value}}
                                        checked style="display:none;">
                                      <div  (click)="itemSelected()">
                                        <input class="hideInput" type="radio" [(ngModel)]="FormValues[DataElement.ID] " name="FormValues['{{DataElement.ID}}']" value={{choice.Value}}
                                          checked>
                                        <span>{{choice.Label}}</span>

                                      </div>

                            </label>
                          </div> </div>
                          </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                  <!-- imagemap will be displyed here -->
                  <ng-container *ngIf="DataElement.ImagePath != undefined">
                    <div class="row">
                      <acr-image-map [DataElement]="DataElement" [DataElements]="DataElements" [FormValues]="FormValues"></acr-image-map>
                    </div>
                  </ng-container>


                </ng-container>
                <!--Multi Choice DataElements-->
                <ng-container *ngIf="DataElement.ElementType == 'MultiChoiceDataElement' ">
                  <ng-container *ngFor="let choice of DataElement.ChoiceOptions">
                    <div class="checkbox">
                      <label >
                        <input type="checkbox" value={{choice.Value}} (change)="updateMultichoice(DataElement.ID,choice.Value,$event)">
                        <span> {{choice.Label}}</span>
                      </label>
                    </div>
                  </ng-container>
                </ng-container>

                <!--NumericDataElement-->
                <ng-container *ngIf="DataElement.ElementType == 'NumericDataElement' ">
                  <input type="number" [(ngModel)]="FormValues[DataElement.ID]" class="form-control" name="FormValues['{{DataElement.ID}}']"
                    (keypress)="itemSelected()">
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  `,
  styles: [`
    /* Master Styles */
    h1 {
      color: #369;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 250%;
    }

    h2,
    h3 {
      color: #444;
      font-family: Arial, Helvetica, sans-serif;
      font-weight: lighter;
    }

    body {
      margin: 2em;
    }

    /*Apply background color for div having checked radio button*/
    input[type="radio"]:checked + div {
      background-color: #1e89b5 !important;

      border: 1px solid #9b9b9b;
      color: #ffffff;
    }

    /*Apply background color for div having no checked radio button*/
    input[type="radio"] + div {
      background-color: #f5f5f5 !important;
      border: 1px solid #9b9b9b;

      border-radius: 5px;
    }

    .checkbox > label {
      background-color: #f5f5f5 !important;
      border: 1px solid #9b9b9b;
      border-radius: 5px;
      height: auto;
      line-height: 25px;
      width: 100%;
      font-weight: bold;
    }

    .checkbox > label > input[type="checkbox"] {
      margin-left: -15px;
      margin-top: 6px;
    }

    .full-width span {
      font-weight: bold;
    }
    /*.checkbox > label > input[type=checkbox]:checked + span {background-color: #FAAF3A !important;
        border: 1px solid #9B9B9B;
        }*/
    .DEElement {
      color: #363636;
      letter-spacing: -0.37px;
      word-wrap: break-word;
    }

    .DEValues {
      /*font-size: 12px;*/
      color: #4a4a4a;
      letter-spacing: -0.29px;
      width: 100%;
        min-width: 200px;
        max-width: 280px;
    }

    /* CHECKBOX OVERWRITE STYLES */
    .rad {
      cursor: pointer;
      -moz-user-select: none;
       -ms-user-select: none;
           user-select: none;
      -webkit-user-select: none;
      -webkit-touch-callout: none;
    }

    .rad > input {
      /* HIDE ORG RADIO & CHECKBOX */
      visibility: hidden;
      position: absolute;
    }

    [type="radio"] + span::before {
      content: "";
      display: inline-block;
      width: 9px;
      height: 9px;
      border-radius: 1em;
      border: 0.1px solid #fff;
      -webkit-box-shadow: 0 0 0 1px #57aed0;
              box-shadow: 0 0 0 1px #57aed0;
      margin-right: 4px;
      -webkit-transition: 0.5s ease all;
      transition: 0.5s ease all;
      margin-left: -15px;
    }

    [type="radio"]:checked + span::before {
      background: #57aed0;
      -webkit-box-shadow: 0 0 0 2px #57aed0;
              box-shadow: 0 0 0 2px #57aed0;
      margin-top: auto;
      /*margin-left:-15px;*/
    }

    .reportText {
      font-size: 14px;
      color: #363636;
      letter-spacing: -0.49px;
      margin-top: 5px;
    }

    button:hover,
    button:focus,
    button.active,
    .btn-default:hover,
    .btn-default:focus,
    .item.active,
    .btn-default.active {
      background: #1e89b5 !important;
      color: #ffffff !important;
    }

    .hideInput {
      visibility: hidden;
      margin-left: 5px !important;
    }

    .panel {
      background-color: transparent;
    }

    .logo {
      height: 30px;
      width: 250px;
    }

    .navbar-blue {
      background-color: #00205b !important;
      color: #fff;
    }

    .navbar-brand-text {
      font-size: 30px;
      color: #fff;
      font-weight: normal;
      margin-top: 10px;
    }
    .close {
      margin-top: -20px !important;
    }
    /*.full-width {
            width: 320px !important;
        }*/

    #myNav.affix {
      width: 483px;
      top: 100;
    }

    #Can-ImgMap {
      pointer-events: none;
      position: absolute;
      opacity: 0.5;
    }

    /* Styles for Assist bootstrap*/

    .row {
      /*margin-top: 30px;*/
    }

    .control-label {
      text-align: left !important;
    }

    .box-style {
      text-decoration: none;
      color: #363636 !important;
      border-radius: 3px;
      padding: 5px;
      font-weight: bold !important;
      width: 75%;
    }

    .findings {
      color: #ffffff !important;
      background-color: #5295b1 !important;
      border-color: #5295b1 !important;
      background-image: none !important;
      font-weight: bold;
      text-transform: capitalize;
      height: 40px;
    }

    .table-row {
      display: table-row;
      width: auto;
      clear: both;
    }

    .table-cell {
      display: table-cell;
      width: 475px;
      font-size: 12px;
      background-color: transparent;
      color: black;
      height: 25px;
      line-height: 25px;
      padding: 1px;
    }

    .imgMap-table-cell {
      width: 10% !important;
      vertical-align: middle;
    }

    .panel-default {
      min-width: 100%;
    }

    #footer {
      position: fixed;
      bottom: 0;
    }

    .row-style {
      bottom: 5px;
      position: fixed;
      top: 55px;
      overflow: auto;
      width: 100%;
    }

    .modal-dialog {
      top: 100px;
      margin-left: 50% !important;
    }

    .required-field {
          border: 1px solid red;
        border-radius: 5px;
        padding: 5px;
        font-size: 12px;
        color: red;
        width: 120px;
        display: inline-block;
        font-weight: bold;
    }

    .col-per-10 {
      border: 1px solid blue;
      padding: 15px 10px 15px 10px;
      border-radius: 10px;
      height: auto;
      width: 10%;
      float: left;
      position: fixed;
      min-height: 1px;
    }

    .btn-group > .btn:first-child {
      margin-left: 0;
      width: 165px;
      margin-top: 10px;
    }

    .col-md-10 {
      left: 200px;
    }

    .module-header {
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
      margin-left: -135px;
      margin-top: -15px;
      font-size: 14px;
      font-weight: bold;
      color: #363636;
    }

    .btn-group-justified {
      padding-left: 15px;
    }

    select {
      height: 35px;
      border-radius: 5px;
      max-width: 280px;
      width: 100%;
    }

    .fixed-keydiagram {
      position: fixed !important;
      float: right;
      padding-right: 0px !important;
      margin-right: 10px;
      padding-left: 25px !important;
    }

    .center-align {
      text-align: center;
      width: 160px !important;
      padding: 0px !important;
    }

    .center-align div {
      width: 200px;
      margin-left: -10px;
    }

    .findings div {
      color: #363636 !important;
      margin-left: 100px !important;
      margin-top: -23.5px !important;
      height: 30px;
    }

    .findings div select {
      text-transform: capitalize;
    }

    .modal-backdrop {
      top: 10000px !important;
    }

    .tooltip-arrow {
      display: none !important;
    }

    .other-reportSection {
      font-weight: normal;
      margin-top: -10px;
      margin-left: 15px;
    }

    a:hover {
      text-decoration: none !important;
    }

    .no-btm-margin-table {
      margin-bottom: 0px !important;
    }

    .adjust-diagram {
      margin-top: 56px;
      right: 20px !important;
    }

    .adjust-diagram-image {
      top: 0px !important;
      margin-top: 0px !important;
    }

    .reportText-panel {
      width: 90%;
      margin-left: 2%;
    }

    .reportText-body {
      margin-left: 2%;
    }
    .top-Index {
      z-index: 99999 !important;
    }
    /* Master Styles */
    h1 {
      color: #369;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 250%;
    }

    h2,
    h3 {
      color: #444;
      font-family: Arial, Helvetica, sans-serif;
      font-weight: lighter;
    }

    .div-simulator-container {
      margin: 0;
    }

    /*Apply background color for div having checked radio button*/
    .div-simulator-container input[type="radio"]:checked + div {
      background-color: #1e89b5 !important;

      border: 1px solid #9b9b9b;
      color: #ffffff;
    }

    /*Apply background color for div having no checked radio button*/
    .div-simulator-container input[type="radio"] + div {
      background-color: #f5f5f5 !important;
      border: 1px solid #9b9b9b;

      border-radius: 5px;
    }

    .div-simulator-container .checkbox > label {
      background-color: #f5f5f5 !important;
      border: 1px solid #9b9b9b;
      border-radius: 5px;
      height: 25px;
      line-height: 25px;
    }

    .div-simulator-container .checkbox > label > input[type="checkbox"] {
      margin-left: -15px;
      margin-top: 6px;
    }

    .div-simulator-container .full-width span {
      font-weight: bold;
    }
    /*.checkbox > label > input[type=checkbox]:checked + span {background-color: #FAAF3A !important;
        border: 1px solid #9B9B9B;
        }*/
    .div-simulator-container .DEElement {
      color: #363636;
      letter-spacing: -0.37px;
      word-wrap: break-word;
    }

    .div-simulator-container .DEValues {
      /*font-size: 12px;*/
      color: #4a4a4a;
      letter-spacing: -0.29px;
    }

    /* CHECKBOX OVERWRITE STYLES */
    .div-simulator-container .rad {
      cursor: pointer;
      -moz-user-select: none;
       -ms-user-select: none;
           user-select: none;
      -webkit-user-select: none;
      -webkit-touch-callout: none;
    }

    .div-simulator-container .rad > input {
      /* HIDE ORG RADIO & CHECKBOX */
      visibility: hidden;
      position: absolute;
    }

    .div-simulator-container [type="radio"] + span::before {
      content: "";
      display: inline-block;
      width: 9px;
      height: 9px;
      border-radius: 1em;
      border: 0.1px solid #fff;
      -webkit-box-shadow: 0 0 0 1px #57aed0;
              box-shadow: 0 0 0 1px #57aed0;
      margin-right: 4px;
      -webkit-transition: 0.5s ease all;
      transition: 0.5s ease all;
      margin-left: -15px;
    }

    [type="radio"]:checked + span::before {
      background: #57aed0;
      -webkit-box-shadow: 0 0 0 2px #57aed0;
              box-shadow: 0 0 0 2px #57aed0;
      margin-top: auto;
      /*margin-left:-15px;*/
    }

    .div-simulator-container .reportText {
      font-size: 14px;
      color: #363636;
      letter-spacing: -0.49px;
    }

    .div-simulator-container button:hover,
    .div-simulator-container button:focus,
    .div-simulator-container button.active,
    .div-simulator-container .btn-default:hover,
    .btn-default:focus,
    .div-simulator-container .item.active,
    .div-simulator-container .btn-default.active {
      background: #1e89b5 !important;
      color: #ffffff !important;
    }

    .div-simulator-container .hideInput {
      visibility: hidden;
      margin-left: 5px !important;
    }

    .div-simulator-container .panel {
      background-color: transparent;
    }

    .logo {
      height: 30px;
      width: 250px;
    }

    .navbar-blue {
      background-color: #00205b !important;
      color: #fff;
    }

    .navbar-brand-text {
      font-size: 30px;
      color: #fff;
      font-weight: normal;
      margin-top: 10px;
    }

    .div-simulator-container .close {
      margin-top: -20px !important;
    }
    /*.full-width {
            width: 320px !important;
        }*/

    #myNav.affix {
      width: 483px;
      top: 100;
    }

    #Can-ImgMap {
      pointer-events: none;
      position: absolute;
      opacity: 0.5;
    }

    /* Styles for Assist bootstrap*/

    .div-simulator-container .control-label {
      text-align: left !important;
    }

    .div-simulator-container .box-style {
      text-decoration: none;
      color: #363636 !important;
      border-radius: 3px;
      padding: 5px;
      font-weight: bold !important;
      width: 75%;
    }

    .div-simulator-container .findings {
      color: #ffffff !important;
      background-color: #5295b1 !important;
      border-color: #5295b1 !important;
      background-image: none !important;
      font-weight: bold;
      text-transform: capitalize;
      height: 40px;
    }

    .div-simulator-container .table-row {
      display: table-row;
      width: auto;
      clear: both;
    }

    .div-simulator-container .table-cell {
      display: table-cell;
      width: 475px;
      font-size: 12px;
      background-color: transparent;
      color: black;
      height: 25px;
      line-height: 25px;
      padding: 1px;
      border-bottom: none;
    }

    .div-simulator-container .imgMap-table-cell {
      width: 10% !important;
      vertical-align: middle;
    }

    .div-simulator-container .panel-default {
      min-width: 600px;
      margin: 0 !important;
      background-color: white;
    }

    .div-simulator-container .footerBlock {
      position: fixed;
      bottom: 55px;
    }

    .div-simulator-container .row-style {
      bottom: 5px;
      position: fixed;
      top: 55px;
      overflow: auto;
      width: 100%;
    }

    .div-simulator-container .modal-dialog {
      top: 100px;
      /*margin-left: 50% !important;*/
      margin-left: 0 !important;
    }

    .div-simulator-container .required-field {
      border: 1px solid #edd1d1;
      border-radius: 5px;
      padding: 5px;
      font-size: 12px;
      color: #cd5c5c;
      width: 125px;
    }

    .div-simulator-container .col-per-10 {
      border: 1px solid blue;
      padding: 15px 10px 15px 10px;
      border-radius: 10px;
      height: auto;
      width: 10%;
      float: left;
      position: fixed;
      min-height: 1px;
    }

    .div-simulator-container .btn-group > .btn:first-child {
      margin-left: 0;
      width: 165px;
      margin-top: 10px;
    }

    .div-simulator-container .col-md-10 {
      left: 200px;
    }

    .div-simulator-container .module-header {
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
      margin-left: -135px;
      margin-top: -15px;
      font-size: 14px;
      font-weight: bold;
      color: #363636;
    }

    .div-simulator-container .btn-group-justified {
      padding-left: 15px;
    }

    .div-simulator-container select {
      height: 28px;
      border-radius: 5px;
    }

    .div-simulator-container .panel-body {
      padding: 10px !important;
    }

    .div-simulator-container .fixed-keydiagram {
      position: fixed !important;
      float: right;
      padding-right: 0px !important;
      margin-right: 10px;
      padding-left: 25px !important;
    }

    .div-simulator-container .center-align {
      text-align: center;
      width: 160px !important;
      padding: 0px !important;
    }

    .div-simulator-container .center-align div {
      width: 200px;
      margin-left: -10px;
    }

    .div-simulator-container .findings div {
      color: #363636 !important;
      margin-left: 97px !important;
      margin-top: -29.5px !important;
      height: 30px;
    }

    .div-simulator-container .findings div select {
      text-transform: capitalize;
    }

    .div-simulator-container .modal-backdrop {
      top: 10000px !important;
    }

    .div-simulator-container .tooltip-arrow {
      display: none !important;
    }

    .div-simulator-container .other-reportSection {
      font-weight: normal;
      margin-top: -10px;
      margin-left: 15px;
    }

    .div-simulator-container a:hover {
      text-decoration: none !important;
    }

    .div-simulator-container .no-btm-margin-table {
      margin-bottom: 0px !important;
    }

    .div-simulator-container .adjust-diagram {
      margin-top: 56px;
      right: 20px !important;
    }

    .adjust-diagram-image {
      top: 0px !important;
      margin-top: 0px !important;
    }

    @media only screen and (min-width: 1224px) {
      .tab-content {
        padding: 5px;
      }
    }

    @media (min-width: 768px) {
      #page-content-wrapper {
        padding: 0px 20px;
        margin-top: 15px;
      }
    }

    #sidebar-wrapper {
      left: 175px;
      margin-left: -175px;
    }

    #rowContent {
      padding-bottom: 120px;
    }

    @media only screen and (min-width: 1224px) {
      .fixed-reportText {
        width: 1064px;
      }
    }

    @media only screen and (min-width: 1824px) {
      .fixed-reportText {
        width: 1260px;
      }
    }

    @media only screen and (min-width: 1224px) {
      .modal-lg {
        left: 0;
        /* left: -250px; */
      }
    }

    .form-group {
      margin-bottom: 15px;
    }

    .control-label {
      margin-top: 0;
      margin-left: 0;
    }

    .div-simulator-container .checkbox > label {
      height: 30px;
      line-height: 30px;
    }

    .div-simulator-container .checkbox > label > input[type="checkbox"] {
      margin-top: 8px;
    }

    .div-simulator-container select {
      height: 30px;
      border-radius: 5px;
      font-size: 12px;
      width: 280px;
    }

    .div-simulator-container .input-group {
      width: 280px;
    }

    .div-simulator-container .input-group .form-control {
      border-radius: 5px;
      -webkit-box-shadow: none;
              box-shadow: none;
      border: 1px solid #969696;
    }

    .div-simulator-container .imgMap-table-cell {
      padding-left: 10px;
    }

    @media (min-width: 1224px) {
      .modal-lg {
        width: 630px;
      }
    }
    .tableImagemap {
      table-layout: fixed;
    }
    @media (min-width: 1850px) {
      .modal-lg {
        width: 900px;
      }
      .tableImagemap {
        table-layout: inherit;
      }
    }
    .col-centered{
      float: none;
      margin: 0 auto;
    }

    .checkbox{
      max-width: 280px;
    }

    [type="number"]{
      max-width: 280px;
      /*margin-left: -15px;*/
    }

    .input-group{
      width: 100%;
    }

    @media (min-width:1441px){
      .DEValues {
        /*min-width: 280px;
        max-width: 280px;*/
        height: auto;
      }
    }

    @media (max-width:1024px){
      .adjust-diagram-image {
        width: 50%;
    }
    }

    @media (min-width:1921px){
      .adjust-diagram-image {
        width: 100%;
    }
    }
    .row {
        font-weight: bold;
    }

    .carousel-item.item img {
        width: 100%;
    }

    .carousel-indicators {
        display: none !important;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: StringUtilityService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'DataElements': [{ type: Input },],
'FormValues': [{ type: Input },],
'ValidationBlocks': [{ type: Input },],
};
}

function DataElementComponent_tsickle_Closure_declarations() {
/** @type {?} */
DataElementComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DataElementComponent.ctorParameters;
/** @type {?} */
DataElementComponent.propDecorators;
/** @type {?} */
DataElementComponent.prototype.DataElements;
/** @type {?} */
DataElementComponent.prototype.FormValues;
/** @type {?} */
DataElementComponent.prototype.ValidationBlocks;
/** @type {?} */
DataElementComponent.prototype.formInitialized;
/** @type {?} */
DataElementComponent.prototype.defaultOption;
/** @type {?} */
DataElementComponent.prototype.stringUtilityService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
